import { get, getOrThrow } from 'quartz/globalState/api';
import { COPILOT_LAYOUT_TYPE, COPILOT_SIDEBAR_SIDE } from './globalState';
/**
 * Returns the name of the current package.
 *
 * @example
 * ```ts
 * import { getCopilotLayoutType } from 'quartz/framework/copilot/service';
 *
 * console.log(getCopilotLayoutType()); // 'sidebar'
 * ```
 */
export const getCopilotLayoutType = () => getOrThrow(COPILOT_LAYOUT_TYPE);
export const getCopilotSidebarSide = () => {
  var _get;
  return (_get = get(COPILOT_SIDEBAR_SIDE)) !== null && _get !== void 0 ? _get : 'right';
};